import PickupRequest from './PickupRequest.vue'

export default PickupRequest
